import React from 'react'
import { RouterProvider } from 'react-router-dom'

import { createApplicationRoutes } from './router'

export const App = () => {
  return <RouterProvider router={createApplicationRoutes()} />
}

export default App
